import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_vm.url ? _c(VRow, {
    style: _vm.responsive || _vm.small ? '' : 'height: 500px;',
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c(VCard, {
    staticClass: "pa-3 elevation-7 mb-3",
    staticStyle: {
      "background-color": "white"
    },
    style: _vm.rotate,
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [_vm.url ? _c('img', {
    style: {
      verticalAlign: 'top'
    },
    attrs: {
      "src": _vm.url,
      "width": _vm.responsive ? 200 : 300
    }
  }) : _vm._e()])], 1) : _vm._e(), _vm.url ? _c(VRow, {
    attrs: {
      "justify": "center"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-undo"
    },
    on: {
      "click": function ($event) {
        _vm.turn = _vm.turn - 0.25;
      }
    }
  }), _c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": "fa-redo"
    },
    on: {
      "click": function ($event) {
        _vm.turn = _vm.turn + 0.25;
      }
    }
  })], 1) : _vm._e(), _c(VRow, {
    attrs: {
      "justify": "center"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "prepend-icon": _vm.buttonIcon || 'fal fa-camera'
    },
    on: {
      "click": _vm.onUploadBtnClick
    }
  }, [_vm._v("\n          " + _vm._s(_vm.buttonText || _vm.$i18n_t('Common.uploadAPicture')) + "\n        ")]), _vm.type == 'image' ? _c('input', {
    ref: "file",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  }) : _vm._e(), _vm.type == 'video' ? _c('input', {
    ref: "file",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "name": "image",
      "accept": "video/*"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  }) : _vm._e(), _vm.type == 'file' ? _c('input', {
    ref: "file",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "name": "image"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  }) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };